// Enumerations
import { IframeIdsEnumeration } from 'components/iframe/enumerations/iframe-ids.enumeration';
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';
// Utils
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const PROOF_INCOME_METHOD_IFRAME_PROPS = {
  [ProofIncomeMethodsEnumeration.OPENBANKING]: {
    frameGap: 178,
    id: IframeIdsEnumeration.OPENBANKING,
  },
  [ProofIncomeMethodsEnumeration.TGSS]: {
    frameGap: 178,
    id: IframeIdsEnumeration.TGSS,
  },
};

export { PROOF_INCOME_METHOD_IFRAME_PROPS };
